import { cn } from '@/lib/utils';

interface LoadingProps {
    className?: string;
    message?: string;
}


export function LoadingPage({ className, message = '' }: LoadingProps) {
    return (
        <div className={cn('min-h-screen bg-background flex flex-col items-center justify-center p-4', className)}>
            <div className="space-y-4 text-center">
                <Spinner className="w-8 h-8 mx-auto" />
                <p className="text-muted-foreground">{message}</p>
            </div>
        </div>
    );
}
export function CenteredSpinner() {
    return (
        <div className="flex items-center justify-center h-full" >
            <Spinner className="w-8 h-8" />
        </div>
    );
}
export default function Spinner({ className = '' }: { className?: string }) {
    return (
        <div
            className={`animate-spin rounded-full border-t-2 border-b-2 ${className}`}
            style={{
                width: 48,
                height: 48,
                borderColor: '#3B82F6',
            }}
        />
    );
}